import React from 'react'
import { FaMinus } from 'react-icons/fa';

function Second() {
  return (
    <section className='second'>
        <div className="left">
            <h1>
                Transact Across <br /> Africa & Beyond
            </h1>

            <p>
                Move money across town, across Africa or across an   ocean. PayZone Cash is the borderless way to send and receive money.
            </p>

            <span>
                <FaMinus/> 
                Get started with PayZone
            </span>
        </div>

        <div className="right">

        </div>
        
    </section>
  )
}

export default Second